import React, {
  Dispatch, SetStateAction, useEffect, useRef, useState,
} from 'react';
import {
  View, StyleSheet, TextInput, ActivityIndicator, FlexStyle,
  Platform,
} from 'react-native';
import Colors from '../constants/Colors';
import Style from '../constants/Style';
import SearchIcon16 from './16pxIcons/SearchIcon16';
import DeleteIcon16 from './16pxIcons/DeleteIcon16';
import PressableStyled from './PressableStyled';
import isMobile from './IsMobile';

interface SearchBarProps {
  apply: Dispatch<SetStateAction<string>>,
  loading: boolean,
  placeholder: string,
  style?: FlexStyle | FlexStyle[],
}

const SearchBar = ({
  apply, loading, placeholder = 'Search', style,
}: SearchBarProps) => {
  const [value, onChangeText] = useState<string>('');
  const [currentTimeout, setCurrentTimeout] = useState(null);
  const [focused, setFocused] = useState<boolean>(false);
  const textInput = useRef<TextInput>(null);

  useEffect(() => {
    clearTimeout(currentTimeout);
    setCurrentTimeout(setTimeout(() => {
      if (value?.length > 2 || value?.length === 0) apply(value);
      clearTimeout(currentTimeout);
    }, 1000));
  }, [value]);

  const clear: () => void = () => {
    onChangeText('');
    textInput.current?.blur();
  };

  return <View style={[styles.container, style]}>
    <TextInput
      placeholderTextColor={Colors.light.hereworksBlack400}
      style={[styles.input, focused && Style.textInputFocused]}
      {...{ value, onChangeText, placeholder }}
      onEndEditing={isMobile ? () => {
        apply(value);
      } : null}
      onFocus={() => setFocused(true)}
      onBlur={() => setFocused(false)}
      ref={textInput}
      numberOfLines={1}
      maxLength={20}
    />
    <ActivityIndicator
      style={styles.loadingIndicator}
      animating={loading && !!value}
    />
    {value?.length > 0 && <PressableStyled
      onPress={clear}
      style={styles.deleteIcon}
      testID='clear-search-field-btn'
    >
      <DeleteIcon16 color={Colors.light.hereworksBlue500} />
    </PressableStyled>}
    <SearchIcon16 style={styles.searchIcon} />
  </View>;
};

const styles = StyleSheet.create({
  container: {
    ...Style.row,
    flex: 1,
  },
  searchIcon: {
    position: 'absolute',
    start: 12,
  },
  input: {
    borderRadius: 4,
    borderWidth: 1.5,
    borderColor: Colors.light.hereworksBlue50,
    height: Platform.OS === 'android' ? undefined : 32,
    flex: 1,
    paddingStart: 36,
    paddingEnd: 66,
    paddingVertical: 8,
    fontSize: 12,
    lineHeight: isMobile ? undefined : 14,
    fontFamily: 'Roboto_400Regular',
    color: Colors.light.hereworksBlack600,
    backgroundColor: '#FFF',
    outlineWidth: 0,
  },
  deleteIcon: {
    position: 'absolute',
    end: 12,
  },
  loadingIndicator: {
    position: 'absolute',
    end: 36,
  },
});

export default SearchBar;
